module.exports = __webpack_public_path__ + "img/header-logo3.626311bf.png";